import React, {useState} from 'react'
import {FaShare} from 'react-icons/fa'
import ShareModal from '@components/ShareModal'
import useReferralCode from '@hooks/useReferralCode.main'
import useInitialData from '@page-components/Layout/useInitialData'

import NotReady from './NotReady'
import useReferralProgramConfig from './useReferralProgramConfig.main'

export default function ReferralProgram({
  showNotReadyMessage = false
}: {
  showNotReadyMessage?: boolean
}) {
  const {loyaltyProgramConfig} = useReferralProgramConfig()
  const [isOpen, setIsOpen] = useState(false)
  const {website} = useInitialData()
  const inactive = loyaltyProgramConfig?.referralProgramConfig?.active !== true
  const referralCode = useReferralCode({omit: inactive})

  if (inactive) return null
  if (!referralCode) return showNotReadyMessage ? <NotReady /> : null

  const shareMessage = `Te comparto mi código de descuento "${referralCode}". Úsalo para tu primer pedido en ${website.baseURL}`

  return (
    <>
      <ShareModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        messageToShare={shareMessage}></ShareModal>
      <div className="flex justify-center">
        <div className="flex max-w-lg flex-col gap-4 rounded-lg bg-gradient-to-br from-purple-600 via-pink-500 to-red-400 p-4 text-white drop-shadow-md">
          <h3 className="font-semibold text-base">
            {loyaltyProgramConfig.referralProgramConfig.referrerTitle}
          </h3>
          <div className="flex h-10 items-center justify-center gap-2">
            <span className="text-2xl font-bold">{referralCode}</span>
            <div className="w-10 cursor-pointer" onClick={() => setIsOpen(true)}>
              <FaShare className="h-8 w-8 rounded-full bg-green-500 p-2 text-lg transition-all duration-200 ease-in-out hover:h-10 hover:w-10 hover:bg-green-600" />
            </div>
          </div>
          <p className="text-center text-sm">
            {loyaltyProgramConfig.referralProgramConfig.referrerMessage}
          </p>
        </div>
      </div>
    </>
  )
}
